import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import App from "./App";
import "./index.css";

/*
  BrowserRouter → clean, crawlable URLs (/services, /landscape-design-noida …)
  instead of HashRouter's /#/services which Google ignores.

  Hydration logic supports react-snap pre-rendering: when the page was
  pre-rendered to static HTML at build time, the #root already has markup, so
  we hydrate it (keeps the server-rendered HTML for crawlers); otherwise we
  render fresh (normal dev / first paint).
*/
const rootElement = document.getElementById("root");

const app = (
  <HelmetProvider>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </HelmetProvider>
);

if (rootElement.hasChildNodes()) {
  ReactDOM.hydrateRoot(rootElement, app);
} else {
  ReactDOM.createRoot(rootElement).render(app);
}